export const ORGANIZATION_ID = 'ORGANIZATION_ID'
export const STORE_ID = 'STORE_ID'
export const WORKSPACE_ID = 'WORKSPACE_ID'

export default {
  ORGANIZATION_ID,
  STORE_ID,
  WORKSPACE_ID,
}
